// 后端通过网站模板接口 resultData.frontendFeatures 下发；未配置时均关闭。
export const DEFAULT_WEBSITE_FEATURES = Object.freeze({
  topCompanyLoginEnabled: false,
  serviceIntegrationEnabled: false,
  serviceThemeEnabled: false,
  // 服务平台位置导航默认关闭，关闭时不渲染返回按钮所在整条位置导航。
  serviceHomeButtonEnabled: false,
  serviceHomeButtonText: '返回首页',
  // 空值表示沿用服务平台主题色，仅在站点显式选择颜色时覆盖。
  serviceHomeButtonTextColor: '',
  operationGuideWebsiteEnabled: false,
  operationGuideServicePlatformEnabled: false
})

// 仅接受十六进制颜色，非法或空值统一回落为空，避免输出不可用样式。
function normalizeButtonTextColor(value) {
  if (typeof value !== 'string') return ''
  const color = value.trim()
  return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(color) ? color : ''
}

export function normalizeWebsiteFeatures(value) {
  let config = value
  if (typeof config === 'string') {
    try {
      config = JSON.parse(config)
    } catch (error) {
      config = null
    }
  }
  const isEnabled = flag => flag === true || flag === 1 || flag === '1' || flag === 'true'
  return {
    topCompanyLoginEnabled: isEnabled(config?.topCompanyLoginEnabled),
    serviceIntegrationEnabled: isEnabled(config?.serviceIntegrationEnabled),
    serviceThemeEnabled: isEnabled(config?.serviceThemeEnabled),
    serviceHomeButtonEnabled: isEnabled(config?.serviceHomeButtonEnabled),
    serviceHomeButtonText: typeof config?.serviceHomeButtonText === 'string'
      ? Array.from(config.serviceHomeButtonText.trim()).slice(0, 4).join('') || '返回首页'
      : '返回首页',
    serviceHomeButtonTextColor: normalizeButtonTextColor(config?.serviceHomeButtonTextColor),
    // 新开关仅接受后端明确的布尔值，未下发、缺失或格式异常均保持关闭。
    operationGuideWebsiteEnabled: config?.operationGuideWebsiteEnabled === true,
    operationGuideServicePlatformEnabled: config?.operationGuideServicePlatformEnabled === true
  }
}

function parseWebsiteFeatures(value) {
  if (typeof value !== 'string') return value && typeof value === 'object' && !Array.isArray(value) ? value : {}
  try {
    const parsed = JSON.parse(value)
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
  } catch (error) {
    return {}
  }
}

// 新版开关随 globalStyle 模块保存；后端聚合字段存在时仍以聚合结果为准。
export function mergeWebsiteFeatures(...values) {
  return normalizeWebsiteFeatures(values.reduce((result, value) => ({
    ...result,
    ...parseWebsiteFeatures(value)
  }), {}))
}
